import {
  CLASSIC_KEYS,
  type ClassicKey,
  type ClassicRaw
} from "../domain/classic-carry-over";

/**
 * ENG-2666: the one place Scheduling V3 reads browser storage that is not its own.
 *
 * Chen approved a read-only read of the classic scheduler's localStorage keys at the moment a
 * person switches to V3 (2026-11-03), and nowhere else. The single-file ESLint override in the
 * root `.eslintrc.json` allows `localStorage` here only; `sessionStorage` and `indexedDB` stay
 * banned. It is called from the switch (`useSwitchScheduler().optIn`), never from V3's own
 * screens, and it never writes: classic must look exactly as it was when someone switches back
 * (AC 10).
 *
 * `null` when storage cannot be read at all (blocked site data, a private window). The switch
 * still happens; V3 opens on its defaults and records the failure (AC 8).
 */
export function readClassicSettings(): ClassicRaw | null {
  try {
    const raw: ClassicRaw = {};
    for (const key of Object.values(CLASSIC_KEYS) as ClassicKey[]) {
      const value = localStorage.getItem(key);
      if (value !== null) raw[key] = value;
    }
    return raw;
  } catch {
    return null;
  }
}
